import * as angular from 'angular';

const templateUrl = require('./spinner.html');

angular.module('ciApp').component('spinner', {
  templateUrl,
  controllerAs: '$spinnerCtrl',
  controller: ['SpinnerService', SpinnerService => new Spinner(SpinnerService)]
});

class Spinner implements ng.IComponentController {
  spinCount: number;

  constructor(SpinnerService: any) {
    this.spinCount = 0;
    SpinnerService.onStart(() => this.start());
    SpinnerService.onStop(() => this.stop());
  }

  start() {
    this.spinCount += 1;
  }

  stop() {
    if (this.spinCount > 0) {
      this.spinCount -= 1;
    }
  }

  isVisible() {
    return this.spinCount > 0;
  }
}



// WEBPACK FOOTER //
// ./common/components/spinner/spinner.component.ts